#import "../../../graphql/fragments/inbox-message-fragment.graphql"

mutation ResendTextMessage($input: TextMessageResendInput!) {
    textResend(input: $input) {
        message {
            ...InboxMessageFragment
        }
    }
}
